import React, { useEffect, useState } from 'react';
import BigNumber from 'bignumber.js';
import { ThreeDots } from 'react-loader-spinner';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { useDispatch } from 'react-redux';
import { alpha } from '@mui/material';
import { IS_DEMO_MODE } from 'config/demo';
import {
  getBidTokenAction,
  getMarketFeeAction,
  setBidTokenPrice,
  setHRC20Decimal,
  setMarketFeePrice,
} from 'store/constants/actions';
import { checkUserExistenceAction, loadUserDataAction } from 'store/user/actions';
import { getHRC20Decimals } from 'services/ContractBasics';
import { getCategoriesService } from 'services/MarketPlace';
import Div from 'components/global/div';
import MetamaskProvider from 'components/providers/Metamask';

const AppProvider: React.FunctionComponent = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const queryClient = new QueryClient();
  const dispatch = useDispatch();

  const coreFetching = async () => {
    try {
      await getCategoriesService();

      if (IS_DEMO_MODE) {
        dispatch(setHRC20Decimal(new BigNumber(18)));
        dispatch(setBidTokenPrice(0.02));
        dispatch(setMarketFeePrice('2.50'));
        setLoading(false);
        return;
      }

      const userExists = Boolean(await dispatch(checkUserExistenceAction() as any));
      await getHRC20Decimals();
      await dispatch(getBidTokenAction());
      await dispatch(getMarketFeeAction());
      if (userExists) {
        await dispatch(loadUserDataAction());
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    coreFetching().finally(() => {});
  }, []);

  if (loading) {
    return (
      <Div
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: theme => alpha(theme.palette.background.default, 0.9),
          zIndex: 100000,
        }}
      >
        <ThreeDots color="#A199AD" />
      </Div>
    );
  }

  return (
    <>
      <QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools />
      </QueryClientProvider>
      {!IS_DEMO_MODE && <MetamaskProvider />}
    </>
  );
};
export default AppProvider;
